module.exports = __webpack_public_path__ + "static/media/connecting-everyone.f31d0aa3.svg";